import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive( {
  selector: '[decimals]'
} )
export class DecimalOnlyDirective {

  private regex: RegExp = new RegExp( /^\d+(\.\d{0,2})?$/g ); // Solo números con hasta 2 decimales
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight']; // Teclas permitidas

  constructor( private el: ElementRef ) { }

  @HostListener( 'keydown', ['$event'] )
  onKeyDown( event: KeyboardEvent ) {
    // Permitir teclas especiales
    if ( this.specialKeys.indexOf( event.key ) !== -1 ) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice( 0, position ), event.key, current.slice( position )].join( '' );

    // Si el valor no coincide con el patrón (números y hasta 2 decimales), prevenir la entrada
    if ( next && !String( next ).match( this.regex ) ) {
      event.preventDefault();
    }
  }

  @HostListener( 'paste', ['$event'] )
  onPaste( event: ClipboardEvent ) {
    const clipboardData = event.clipboardData;
    const pastedInput: string = clipboardData?.getData( 'text' ) || '';

    if ( pastedInput && !String( pastedInput ).match( this.regex ) ) {
      event.preventDefault();
    }
  }
}
